import React from "react";
import PropTypes from "prop-types";

import Tile, { TileHeader } from "shared/react_components/Tile";
import Transcript, { TranscriptLegend } from "shared/react_components/Transcript";

const TranscriptPane = ({ className, events, currentAudioPosition, onAudioJumpPosition, enableAutoScroll, onAddComment }) => (
  <Tile className={className}>
    <TileHeader className="d-flex align-items-center justify-content-between">
      <h1>Transcript</h1>
      <TranscriptLegend/>
    </TileHeader>
    <Transcript
      events={events}
      position={currentAudioPosition}
      onAudioJumpPosition={onAudioJumpPosition}
      enableAutoScroll={enableAutoScroll}
      onAddComment={onAddComment}
    />
  </Tile>
);

TranscriptPane.propTypes = {
  className: PropTypes.string,
  events: PropTypes.array.isRequired,
  currentAudioPosition: PropTypes.number,
  onAudioJumpPosition: PropTypes.func,
  enableAutoScroll: PropTypes.bool.isRequired,
  onAddComment: PropTypes.func
};

TranscriptPane.defaultProps = {
  className: ""
};

export default TranscriptPane;
